import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { setLastMarketPath } from "../../utils/lastMarket";

export const Trading = () => {
  const location = useLocation();

  // Remember the market the trader is viewing so returning to "Markets" (after a
  // detour to Portfolio/Vaults) brings them back to that same market, not the default.
  useEffect(() => {
    setLastMarketPath(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Outlet />
    </>
  );
};
